import { useTranslation } from '@eti/providers';
import { LinkButton, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useDynamicIcon } from '../../common/utils/dynamic-icons/useDynamicIcon';
import { DYNAMIC_ICON } from '../../common/utils/dynamic-icons/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  display: grid;
  grid-column-start: 2;
  justify-content: end;
`;
const iconStyles = content => css`
  content: ${content};
  display: grid;
  grid-row-start: 1;
  height: 18px;
`;
const linkButtonStyles = css`
  grid-row-start: 1;
`;
const SeatMapCardChangeSelection = _ref => {
  let {
    onClick
  } = _ref;
  const {
    t
  } = useTranslation();
  const label = t('Product.SeatMap.Change');
  const [icon] = useDynamicIcon(vars.colors.links.default, DYNAMIC_ICON.editIcon);
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperStyles,
    children: [/*#__PURE__*/_jsx("div", {
      className: iconStyles(icon),
      "data-testid": "edit-icon"
    }), /*#__PURE__*/_jsx(LinkButton, {
      className: linkButtonStyles,
      "data-testid": "seatMapChangeSelection-button",
      onClick: onClick,
      children: label
    })]
  });
};
export default SeatMapCardChangeSelection;
//# sourceMappingURL=SeatMapCardChangeSelection.js.map